export const convertedDocumentLink = (link: string): string => {
    // Convert the link to a format suitable for the application
    // This function can be customized based on specific requirements
    return link.toLowerCase()
    .replace(/[&\/\\#,;+()$~%.'":*?<>{}]/g, '') // Remove special characters
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/®|–/g, '-') // Replace specific characters with hyphens
    .replace(/’|/g, '') // Remove curly apostrophes
}